import React from 'react';
import './ErrorBoundary.css';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console in dev; in prod you'd send to Sentry/Datadog
    console.error('[Oakdesk Error]', error, errorInfo);
  }

  reset = () => this.setState({ hasError: false, error: null, errorInfo: null });

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, errorInfo } = this.state;
    const isDev = process.env.NODE_ENV === 'development';

    return (
      <div className="eb-root">
        <div className="eb-card">
          <div className="eb-icon">⚠️</div>
          <h2 className="eb-title">Something went wrong</h2>
          <p className="eb-sub">
            This section encountered an unexpected error.
            Your data is safe — try refreshing or navigating to another page.
          </p>
          <div className="eb-actions">
            <button className="eb-btn eb-btn--primary" onClick={this.reset}>
              Try again
            </button>
            <button className="eb-btn eb-btn--ghost" onClick={() => window.location.reload()}>
              Reload page
            </button>
          </div>
          {isDev && error && (
            <details className="eb-details">
              <summary>Error details (dev only)</summary>
              <pre className="eb-stack">{error.toString()}</pre>
              {errorInfo?.componentStack && (
                <pre className="eb-stack">{errorInfo.componentStack}</pre>
              )}
            </details>
          )}
        </div>
      </div>
    );
  }
}

/** Lightweight wrapper for individual view-level boundaries */
export function ViewErrorBoundary({ children, viewName }) {
  return (
    <ErrorBoundary key={viewName}>
      {children}
    </ErrorBoundary>
  );
}
